<template>
  <font-awesome-icon
    :class="className"
    :icon="[type, icon]"
    :size="size" />
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'sm'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
